import { alertCtk } from './utils';

const jQuery = window.jQuery;
const cnfg_http_eshoplocal_phpajax_base =
  window.cnfg_http_eshoplocal_phpajax_base;
const cnfg_http_mojectk_php_base = window.cnfg_http_mojectk_php_base;

export function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function escapeString(text) {
  return text.replace(/"/g, '"').replace(/'/g, "'");
}

export const checkOkStatusInSuccessFunc = (result, textStatus, jqXHR) => {
  console.log('test returned error');
  const status = jqXHR.status;
  if (status !== 200) {
    alertCtk(
      'Komunikace se serverem selhala, případně byly zadány nepovolené hodnoty!',
    );
    return false; //not ok
  }
  try {
    const parsed = JSON.parse(result.trim());
  } catch (e) {
    alertCtk(
      'Komunikace se serverem selhala, případně byly zadány nepovolené hodnoty.',
    );
    return false; //not ok
  }
  return true; //ok
};

const generalErrorFunc = (jqXHR, textStatus, errorThrown) => {
  console.log('login returned error');
  const status = jqXHR.status;
  if (status !== 200) {
    alertCtk(
      'Komunikace se serverem selhala, případně byly zadány nepovolené hodnoty',
    );
  }
};

export function ajaxUniGet(cmd, jsondata, successFunc) {
  jQuery.ajax({
    xhrFields: { withCredentials: true },
    url:
      cnfg_http_eshoplocal_phpajax_base +
      'universal.php?cmd=' +
      cmd +
      '&jsondata=' +
      encodeURI(JSON.stringify(jsondata)),
    success: successFunc,
  });
}
export function ajaxUniPostUsingCaptcha(
  cmd,
  jsondata,
  successFunc,
  recaptchaActionName,
) {
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6LfxYRYdAAAAAL_sGy8Fg8jNNf3NA7gECot1F4GB', {
        action: recaptchaActionName,
      })
      .then(function (grecaptchatoken) {
        // Add your logic to submit to your backend server here.
        ajaxUniPostCaptcha(cmd, jsondata, successFunc, grecaptchatoken);
      });
  });
}

function ajaxUniPostCaptcha(cmd, jsondata, successFunc, grecaptchatoken) {
  jQuery.ajax({
    type: 'POST',
    xhrFields: { withCredentials: true },
    url: cnfg_http_eshoplocal_phpajax_base + 'universalpost.php',
    data: {
      cmd,
      jsondata: JSON.stringify(jsondata),
      grecaptchatoken: grecaptchatoken,
    },
    success: successFunc,
    error: generalErrorFunc,
  });
}
export function ajaxUniPost(cmd, jsondata, successFunc) {
  jQuery.ajax({
    type: 'POST',
    xhrFields: { withCredentials: true },
    url: cnfg_http_eshoplocal_phpajax_base + 'universalpost.php',
    data: { cmd, jsondata: JSON.stringify(jsondata) },
    success: successFunc,
  });
}
export function ajaxPlatebniBranaPost(jsondata, crc) {
  const redirect = cnfg_http_mojectk_php_base + 'final.php'; // http://localhost/ctk24/final.php
  //const url1 =    'https://shop.ctk.cz/platba?src=CTK24&redirect=' +    redirect +    '&data=' +    encodeURI(JSON.stringify(res));
  // + '&crc=' +  parsed.crc;
  submitPostNonAjax('https://shop.ctk.cz/platba', 'POST', [
    { name: 'src', value: 'CTK24' },
    { name: 'data', value: JSON.stringify(jsondata) },
    { name: 'redirect', value: redirect },
    { name: 'cr', value: crc },
  ]);
}

export const ajaxUniPut = ajaxUniPost;
export const ajaxUniDelete = ajaxUniPost;

export function ajaxLoginUsingCaptcha(email, jsondata, successFunc) {
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6LfxYRYdAAAAAL_sGy8Fg8jNNf3NA7gECot1F4GB', { action: 'login' })
      .then(function (grecaptchatoken) {
        // Add your logic to submit to your backend server here.
        jQuery.ajax({
          type: 'POST',
          url: cnfg_http_eshoplocal_phpajax_base + 'login.php',
          data: {
            email,
            jsondata: JSON.stringify(jsondata),
            grecaptchatoken: grecaptchatoken,
          },
          success: successFunc,
          error: generalErrorFunc,
        });
      });
  });
}

export function ajaxLogout(successFunc) {
  jQuery.ajax({
    xhrFields: { withCredentials: true },
    url: cnfg_http_eshoplocal_phpajax_base + 'logout.php',
    success: successFunc,
  });
}

export function submitPostNonAjax(action, method, values) {
  var form = jQuery('<form/>', {
    action: action,
    method: method,
  });
  jQuery.each(values, function () {
    form.append(
      jQuery('<input/>', {
        type: 'hidden',
        name: this.name,
        value: this.value,
      }),
    );
  });
  form.appendTo('body').submit();
}
